(function () {
  function initGallery(gallery) {
    if (gallery.hasAttribute('data-shop-merchandise-gallery-no-nav')) return;

    const slides = gallery.querySelectorAll('[data-shop-merchandise-gallery-slide]');
    if (slides.length <= 1) return;

    const prevBtn = gallery.querySelector('[data-shop-merchandise-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-shop-merchandise-gallery-next]');
    let activeIndex = 0;

    const setActive = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
      });
    };

    prevBtn?.addEventListener('click', () => setActive(activeIndex - 1));
    nextBtn?.addEventListener('click', () => setActive(activeIndex + 1));
  }

  function initSection(section) {
    section.querySelectorAll('[data-shop-merchandise-gallery]').forEach(initGallery);
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.shop-merchandise, .collection-festive-one15').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.shop-merchandise') || event.target.querySelector('.collection-festive-one15') || event.target;
    if (section?.classList?.contains('shop-merchandise') || section?.classList?.contains('collection-festive-one15')) {
      initSection(section);
    }
  });
})();
